import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { findMinSignedExpiryMs } from 'helpers/signedUrl'

// Import this if you have it:
type VaultMediaResponse = {
  data: any[];
  nextPage: number | null;
  existingIds: string[];
};

interface VaultCacheState {
  mediaCache: Record<string, VaultMediaResponse>;
  setVaultMedia: (key: string, resp: VaultMediaResponse) => void;
  getVaultMedia: (key: string) => VaultMediaResponse | undefined;
  removeMedia: (key: string) => void;
  clear: () => void;
}

export const useVaultCacheStore = create<VaultCacheState>()(
  persist(
    (set, get) => ({
      mediaCache: {},

      setVaultMedia: (key, resp) =>
        set(state => ({
          mediaCache: {
            ...state.mediaCache,
            [key]: resp
          }
        })),

      getVaultMedia: key => {
        const cached = get().mediaCache[key]

        if (!cached) return undefined

        const expiresAt = findMinSignedExpiryMs(cached.data)

        if (
          expiresAt != null &&
          Date.now() >= expiresAt - 10 * 60 * 1000
        ) {
          return undefined
        }

        return cached
      },

      removeMedia: key => {
      const cache = { ...get().mediaCache };
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete cache[key];
      set({ mediaCache: cache });
    },

      clear: () => set({ mediaCache: {} }),
    }),
    {
      name: 'vault-cache',
      partialize: state => ({
        mediaCache: state.mediaCache,
      }),
    }
  )
);
